const companySize = [
    '1-10 Employees',
    '10-50 Employees',
    '50-100 Employees',
    '100-500 Employees',
    '500-1000 Employees',
    '1000+ Employees'
]
export default companySize;